
import {
  defineComponent,
  onMounted,
  reactive,
  computed,
  SetupContext
} from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import FormRadioButtons from '@/components/block/FormRadioButtons.vue'
import GoalButtons from '@/components/block/GoalButtons.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import Button from '@/components/elements/Button.vue'

export default defineComponent({
  name: 'RegistUserCategory',

  props: {
    data: Object
  },

  components: {
    FormRadioButtons,
    GoalButtons,
    HeadingLv3,
    Button
  },

  setup(props: any, context: SetupContext) {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()

    // 入力ページから入ってきているステータスを設定
    context.emit('update-landing-state', true)

    // ヒポクラの紹介コードがある場合はコードを保持する
    if (route.query.invitationCode)
      context.emit('set-invitation-code', route.query.invitationCode)

    interface Item {
      label: string
      value: string
      id: string
    }

    const items: Array<Item> = reactive([])

    store.state.master.memberType.forEach((el: any) => {
      if (el.opt_id === '0') return

      const item: Item = {
        label: el.option_name,
        value: el.opt_id,
        id: 'memberType' + el.opt_id
      }
      items.push(item)
    })

    const isDisabledNextBtn = computed(() => {
      return props.data.memberType ? false : true
    })

    const updateMemberType = (value: string) => {
      context.emit('update-member-type', value)
    }

    const goForward = () => {
      router.push('/register/area')
    }

    onMounted(() => {
      context.emit('update-flow', 1)
      document.title = `会員登録 | ${document.title}`
    })

    return {
      items,
      updateMemberType,
      isDisabledNextBtn,
      goForward
    }
  }
})
